import { gql } from "@apollo/client";

export default gql`
  query AvailableStatesWithCountries {
    availableStatesWithCountries {
      country
      state
      friendlyStateName
    }
  }
`;
